import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M14.53 7.47a.75.75 0 0 0-1.06 0l-2.72 2.72V3a.75.75 0 0 0-1.5 0v7.19L6.53 7.47a.75.75 0 0 0-1.06 1.06l4 4a.75.75 0 0 0 1.06 0l4-4a.75.75 0 0 0 0-1.06M3 13.25a.75.75 0 0 1 .75.75v1c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-1a.75.75 0 0 1 1.5 0v1A2.75 2.75 0 0 1 15 17.75H5A2.75 2.75 0 0 1 2.25 15v-1a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgExport;
